/**
 * Cleans up a Qwoted Top Hundred entry by removing specific fields.
 *
 * @param {Object} data - A single Qwoted Top Hundred entry.
 * @returns {Object} The cleaned-up object with unwanted fields removed.
 */
export default function cleanupQwotedTopHundredEntry(data) {
  /* eslint-disable camelcase */
  // Destructure unwanted fields out of the object
  const { email, profile_image_url, profile_name, company_name, company_slug, ...keep } = data;
  /* eslint-enable camelcase */

  // Return the remaining fields (excluding the destructured ones)
  return keep;
}
